// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phase-roundtrip-fixture-selector-modal .modal2__container{
    padding: 0;
    width: 50%;
}

.phase-roundtrip-fixture-selector__title {
    text-align: start;
    margin: var(--space);
}

.phase-roundtrip-fixture-selector__text.baloa-body-2 {
    max-width: 280px;
    margin-top: var(--space);
    justify-content: center;
    font-size: var(--space);
    color: var(--primary-dark-color) !important;
    
}

.phase-roundtrip-fixture-selector__actions {
    margin-top: var(--space);
    margin-bottom: var(--space-x2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.phase-roundtrip-fixture-selector__button {
    display: block;
    width: 76%;
    margin-top: var(--space-half-quarter);
    
}

.phase-roundtrip-fixture-selector__title.baloa-table-column{
    line-height: 21.09px;
}

/* .phases_round_fixture_selector_modal-stepper {
    margin-bottom: calc( var(--space-x3) + var(--space-half) + var(--space-eighth));
} */

.phases_round_fixture_selector_modal-container_stepper{
    background-color: #F3F5F7;
    height: 70px;
    padding: 10px 130px
}

.phases_round_fixture_selector_modal_step-point__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.phases_round_fixture_selector_modal_step-point {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.phases_round_fixture_selector_modal_step-point .phases_round_fixture_selector_modal_point {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: var( --new-gray-disabled-color );
    z-index: 2;
}

.phases_round_fixture_selector_modal_step-point .baloa-username{
    margin-bottom: var(--space-quarter);
}

.baloa-username.phases_round_fixture_selector_modal_step-point-label-completed {
    color: var( --new-green-color );
    margin-bottom: var(--space-quarter);
}

.phases_round_fixture_selector_modal_point.phases_round_fixture_selector_modal_step-point-completed {
    background: var( --new-green-color );
}

.phases_round_fixture_selector_modal_step-line__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line {
    border-bottom: 2px solid var( --new-gray-disabled-color );
    height: 0;
    width: 100%;
    position: relative;
    top: -12px;
}

.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line:first-of-type {
    margin-left: var( --space-x3 );
}

.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line:last-of-type {
    margin-right: var( --space-x3 );
}

.phases_round_fixture_selector_modal_step-line.phases_round_fixture_selector_modal_step-line-completed {
    border-bottom: 2px solid var( --new-green-color );
}

.phases_round_fixture_selector_modal-box{
    margin: 1rem 3rem;
    max-height: calc(100vh - 180px);
}

.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select{
    width: 50%;
}

.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select.select-field{
    margin: var(--space-half) 0;
}

.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select.select-field .select-field-input{
    background-color: transparent;
    border: 1px solid #E7E7E7;
}
.phases_round_fixture_selector_modal-switch{
    display: flex;
    align-items: center;
}

.phases_round_fixture_selector_modal_button{
    border-top: 1px solid #E7E7E7;
    display: flex;
    justify-content: end;
}

.phases_round_fixture_selector_modal_button .modal_button{
    margin: 12px 16px 12px 24px;
}

.phases_round_fixture_selector_modal_button .button.small{
    padding: 10px 20px;
}

.phases_round_fixture_selector_modal__date {
    max-width: 194px;
    margin: 20px 0 0 0;
}

.phases_round_fixture_selector_modal__date .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.phases_round_fixture_selector_modal__date .input-field-label,
.phases_round_fixture_selector_modal__number .input-field-label,
.phases_round_fixture_selector_modal__time .input-field-label {
    font-size: 14px;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.phases_round_fixture_selector_modal__number {
    margin: 40px 0 0 0;
}

.phases_round_fixture_selector_modal__number .input-field-input {
    max-width: 133px;
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.phases_round_fixture_selector_modal__time {
    max-width: 75px;
}

.phases_round_fixture_selector_modal__time .select-field-label {
    top: 5px;
    left: 90px;
    font-size: 14px;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.phases_round_fixture_selector_modal__time .select-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.phases_round_fixture_selector_modal__time.select-field {
    margin: 0;
}

.phases_round_fixture_selector_modal__time-between {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 100px;
    margin-top: 4px;
}

.phases_round_fixture_selector_modal__time-between .select-field__message {
    position: relative;
}

.phases_round_fixture_selector_modal__days {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    padding: 16px;
    margin-top: 16px;
}

.phases_round_fixture_selector_modal__days .baloa-table-column {
    color: var(--primary-very-dark-color);
}

.phases_round_fixture_selector_modal__days .baloa-username {
    color: var(--primary-very-dark-color);
    margin-top: 10px;
}

.phases_round_fixture_selector_modal__days__button.rounded-button.small {
    padding: 6px 8px !important;
    height: fit-content;
    font-size: 14px;
}

.phases_round_fixture_selector_modal__days .hubicon-event_available,
.phases_round_fixture_selector_modal__days .hubicon-event_busy {
    margin-right: 4px;
    font-size: 18px;
}

.phases_round_fixture_selector_modal__days .hubicon-event_available::before,
.phases_round_fixture_selector_modal__days .hubicon-event_busy::before {
    color: var(--basic-gray-color);
}

.phases_round_fixture_selector_modal__days__button span.icon{
    grid-area: icon;
    margin-right: 4px;
}

.phases_round_fixture_selector_modal__days-container {
    display: flex;
    margin-top: 12px;
    gap: 8px;
    flex-wrap: wrap;
}

.phases_round_fixture_selector_modal__days-tag {
    border-radius: 25px;
    border: 1px solid var(--new-gray-background-color);
    width: fit-content;
    padding: 8px;
    display: flex;
    align-items: center;
}

.phases_round_fixture_selector_modal__days-tag__date-info {
    text-align: center;
    padding: 0 12px;
}

.phases_round_fixture_selector_modal__days-tag__button {
    cursor: pointer;
}

.phases_round_fixture_selector_modal__days-tag__button .hubicon-clear_option{
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.phases_round_fixture_selector_modal__days-tag__date-info .baloa-username {
    margin-top: 0;
    color: var(--primary-very-dark-color);
    text-transform: capitalize;
}

.phases_round_fixture_selector_modal__days-tag__date-info .baloa-mini {
    color: var(--primary-dark-color);
}

.phases_round_fixture_selector_modal__time-between__title.baloa-username{
    color: var(--primary-very-dark-color);
    margin-top: 20px;
}

#menu-time_between_games_hour .MuiMenu-paper,
#menu-time_between_games_minutes .MuiMenu-paper {
    max-height: 400px;
}

#menu-time_between_games_hour .MuiPaper-root {
    top: -150px;
}

.phases_round_fixture_selector_modal__empty-fields {
    margin-top: 16px;
    text-align: center;
    padding: 16px;
    border: 1px solid var(--new-gray-background-color);
}

.phases_round_fixture_selector_modal__empty-fields .baloa-table-column {
    margin-top: 12px;
    color: var(--basic-gray-color);
}

.phases_round_fixture_selector_modal__empty-fields .baloa-table-column.green {    
    color: var(--new-green-color);
    cursor: pointer;
}

.phases_round_fixture_selector_modal__field-btn-options {
    padding: 8px;
    background-color: var(--white-color);
    border-radius: 8px;
    flex-direction: column;
    gap: 4px;
    box-shadow: var(--shadow);
    position: fixed;
    margin-top: 4px;
    display: none;
    margin-left: calc(100vw - 74vw);
}

.phases_round_fixture_selector_modal__field-btn-options.open {
    display: flex;
    align-items: flex-start;
}

.phases_round_fixture_selector_modal__field-btn-options .baloa-names {
    color: var(--primary-very-dark-color);
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.phases_round_fixture_selector_modal__field-btn-options .baloa-names:hover {
    background-color: var(--new-background-color);
}

.phases_round_fixture_selector_modal__info-msg {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    border-radius: 4px;
    background-color: var(--new-informative-banner-bg-color);
    margin-top: 20px;
    margin-bottom: 20px;
}

.phases_round_fixture_selector_modal__info-msg .baloa-username {
    font-weight: var(--font-medium);
}

.phases_round_fixture_selector_modal__info-msg .hubicon-info::before {
    color: var(--new-informative-banner-color);
    font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/phase-roundtrip-fixture-selector-modal/PhaseRoundtripFixtureSelectorModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;IACvB,2CAA2C;;AAE/C;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qCAAqC;;AAEzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,+BAA+B;IAC/B,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;IACf,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,eAAe;IACf,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,wDAAwD;IACxD,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB","sourcesContent":[".phase-roundtrip-fixture-selector-modal .modal2__container{\n    padding: 0;\n    width: 50%;\n}\n\n.phase-roundtrip-fixture-selector__title {\n    text-align: start;\n    margin: var(--space);\n}\n\n.phase-roundtrip-fixture-selector__text.baloa-body-2 {\n    max-width: 280px;\n    margin-top: var(--space);\n    justify-content: center;\n    font-size: var(--space);\n    color: var(--primary-dark-color) !important;\n    \n}\n\n.phase-roundtrip-fixture-selector__actions {\n    margin-top: var(--space);\n    margin-bottom: var(--space-x2);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.phase-roundtrip-fixture-selector__button {\n    display: block;\n    width: 76%;\n    margin-top: var(--space-half-quarter);\n    \n}\n\n.phase-roundtrip-fixture-selector__title.baloa-table-column{\n    line-height: 21.09px;\n}\n\n/* .phases_round_fixture_selector_modal-stepper {\n    margin-bottom: calc( var(--space-x3) + var(--space-half) + var(--space-eighth));\n} */\n\n.phases_round_fixture_selector_modal-container_stepper{\n    background-color: #F3F5F7;\n    height: 70px;\n    padding: 10px 130px\n}\n\n.phases_round_fixture_selector_modal_step-point__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.phases_round_fixture_selector_modal_step-point {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.phases_round_fixture_selector_modal_step-point .phases_round_fixture_selector_modal_point {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background: var( --new-gray-disabled-color );\n    z-index: 2;\n}\n\n.phases_round_fixture_selector_modal_step-point .baloa-username{\n    margin-bottom: var(--space-quarter);\n}\n\n.baloa-username.phases_round_fixture_selector_modal_step-point-label-completed {\n    color: var( --new-green-color );\n    margin-bottom: var(--space-quarter);\n}\n\n.phases_round_fixture_selector_modal_point.phases_round_fixture_selector_modal_step-point-completed {\n    background: var( --new-green-color );\n}\n\n.phases_round_fixture_selector_modal_step-line__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line {\n    border-bottom: 2px solid var( --new-gray-disabled-color );\n    height: 0;\n    width: 100%;\n    position: relative;\n    top: -12px;\n}\n\n.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line:first-of-type {\n    margin-left: var( --space-x3 );\n}\n\n.phases_round_fixture_selector_modal_step-line__container .phases_round_fixture_selector_modal_step-line:last-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.phases_round_fixture_selector_modal_step-line.phases_round_fixture_selector_modal_step-line-completed {\n    border-bottom: 2px solid var( --new-green-color );\n}\n\n.phases_round_fixture_selector_modal-box{\n    margin: 1rem 3rem;\n    max-height: calc(100vh - 180px);\n}\n\n.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select{\n    width: 50%;\n}\n\n.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select.select-field{\n    margin: var(--space-half) 0;\n}\n\n.phases_round_fixture_selector_modal-select .phases_round_fixture_option_list_body_select.select-field .select-field-input{\n    background-color: transparent;\n    border: 1px solid #E7E7E7;\n}\n.phases_round_fixture_selector_modal-switch{\n    display: flex;\n    align-items: center;\n}\n\n.phases_round_fixture_selector_modal_button{\n    border-top: 1px solid #E7E7E7;\n    display: flex;\n    justify-content: end;\n}\n\n.phases_round_fixture_selector_modal_button .modal_button{\n    margin: 12px 16px 12px 24px;\n}\n\n.phases_round_fixture_selector_modal_button .button.small{\n    padding: 10px 20px;\n}\n\n.phases_round_fixture_selector_modal__date {\n    max-width: 194px;\n    margin: 20px 0 0 0;\n}\n\n.phases_round_fixture_selector_modal__date .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.phases_round_fixture_selector_modal__date .input-field-label,\n.phases_round_fixture_selector_modal__number .input-field-label,\n.phases_round_fixture_selector_modal__time .input-field-label {\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.phases_round_fixture_selector_modal__number {\n    margin: 40px 0 0 0;\n}\n\n.phases_round_fixture_selector_modal__number .input-field-input {\n    max-width: 133px;\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.phases_round_fixture_selector_modal__time {\n    max-width: 75px;\n}\n\n.phases_round_fixture_selector_modal__time .select-field-label {\n    top: 5px;\n    left: 90px;\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.phases_round_fixture_selector_modal__time .select-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.phases_round_fixture_selector_modal__time.select-field {\n    margin: 0;\n}\n\n.phases_round_fixture_selector_modal__time-between {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 100px;\n    margin-top: 4px;\n}\n\n.phases_round_fixture_selector_modal__time-between .select-field__message {\n    position: relative;\n}\n\n.phases_round_fixture_selector_modal__days {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    padding: 16px;\n    margin-top: 16px;\n}\n\n.phases_round_fixture_selector_modal__days .baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.phases_round_fixture_selector_modal__days .baloa-username {\n    color: var(--primary-very-dark-color);\n    margin-top: 10px;\n}\n\n.phases_round_fixture_selector_modal__days__button.rounded-button.small {\n    padding: 6px 8px !important;\n    height: fit-content;\n    font-size: 14px;\n}\n\n.phases_round_fixture_selector_modal__days .hubicon-event_available,\n.phases_round_fixture_selector_modal__days .hubicon-event_busy {\n    margin-right: 4px;\n    font-size: 18px;\n}\n\n.phases_round_fixture_selector_modal__days .hubicon-event_available::before,\n.phases_round_fixture_selector_modal__days .hubicon-event_busy::before {\n    color: var(--basic-gray-color);\n}\n\n.phases_round_fixture_selector_modal__days__button span.icon{\n    grid-area: icon;\n    margin-right: 4px;\n}\n\n.phases_round_fixture_selector_modal__days-container {\n    display: flex;\n    margin-top: 12px;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.phases_round_fixture_selector_modal__days-tag {\n    border-radius: 25px;\n    border: 1px solid var(--new-gray-background-color);\n    width: fit-content;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.phases_round_fixture_selector_modal__days-tag__date-info {\n    text-align: center;\n    padding: 0 12px;\n}\n\n.phases_round_fixture_selector_modal__days-tag__button {\n    cursor: pointer;\n}\n\n.phases_round_fixture_selector_modal__days-tag__button .hubicon-clear_option{\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.phases_round_fixture_selector_modal__days-tag__date-info .baloa-username {\n    margin-top: 0;\n    color: var(--primary-very-dark-color);\n    text-transform: capitalize;\n}\n\n.phases_round_fixture_selector_modal__days-tag__date-info .baloa-mini {\n    color: var(--primary-dark-color);\n}\n\n.phases_round_fixture_selector_modal__time-between__title.baloa-username{\n    color: var(--primary-very-dark-color);\n    margin-top: 20px;\n}\n\n#menu-time_between_games_hour .MuiMenu-paper,\n#menu-time_between_games_minutes .MuiMenu-paper {\n    max-height: 400px;\n}\n\n#menu-time_between_games_hour .MuiPaper-root {\n    top: -150px;\n}\n\n.phases_round_fixture_selector_modal__empty-fields {\n    margin-top: 16px;\n    text-align: center;\n    padding: 16px;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.phases_round_fixture_selector_modal__empty-fields .baloa-table-column {\n    margin-top: 12px;\n    color: var(--basic-gray-color);\n}\n\n.phases_round_fixture_selector_modal__empty-fields .baloa-table-column.green {    \n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.phases_round_fixture_selector_modal__field-btn-options {\n    padding: 8px;\n    background-color: var(--white-color);\n    border-radius: 8px;\n    flex-direction: column;\n    gap: 4px;\n    box-shadow: var(--shadow);\n    position: fixed;\n    margin-top: 4px;\n    display: none;\n    margin-left: calc(100vw - 74vw);\n}\n\n.phases_round_fixture_selector_modal__field-btn-options.open {\n    display: flex;\n    align-items: flex-start;\n}\n\n.phases_round_fixture_selector_modal__field-btn-options .baloa-names {\n    color: var(--primary-very-dark-color);\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 4px;\n    white-space: nowrap;\n}\n\n.phases_round_fixture_selector_modal__field-btn-options .baloa-names:hover {\n    background-color: var(--new-background-color);\n}\n\n.phases_round_fixture_selector_modal__info-msg {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: var(--new-informative-banner-bg-color);\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.phases_round_fixture_selector_modal__info-msg .baloa-username {\n    font-weight: var(--font-medium);\n}\n\n.phases_round_fixture_selector_modal__info-msg .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n    font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
